export const DomainType = Object.freeze({
  MAIN: 'main',
  ALTERNATIVE: 'alternative',
  TEMPORARY: 'temporary'
})
